import { Component, EventEmitter, Input } from '@angular/core';
import { ProjectService } from '../../_core/services/project.service';
import { IFramedElement } from 'src/app/_core/interfaces/IFramedElement';
import { FrameMode, FrameProfile } from 'src/app/_core/models/profiles/frame.model';
import { ElementSide } from 'src/app/_core/interfaces/IElementSide';

@Component({
	selector: 'frames-picker',
	templateUrl: './frames-picker.component.html',
	styleUrls: ['./../../card/card.component.css']
})
export class FramesPickerComponent {
	@Input() current: IFramedElement;
	public changed = new EventEmitter();
	

	constructor(public projectService: ProjectService) { }

	change(f: FrameProfile) {
		if (f.mode == FrameMode.On || (f.mode == FrameMode.Auto && f.visible)) {
			f.mode = FrameMode.Off;
		} else {
			f.mode = FrameMode.On;
		}
		this.changed.emit();
	}

	isEnabled(side: string): boolean {
		if (this.projectService.readOnly) {
			return true;
		}
		const sideStr = side.toLowerCase() + 'Frame';
		const frame = this.current[sideStr] as FrameProfile

		if (frame?.visible) {
			return true;
		}

		return this.current.canAddFrame(ElementSide[side]);
	}
}
